// @flow

import { refreshSessionToken } from './samlService';

export const errorObject = {
  errorCode: 'INTERNAL_ERROR',
  statusArguments: [],
};

export const unauthorizedObject = {
  errorCode: 'UNAUTHORIZED',
  statusArguments: [],
};

export function rawResponseCatcher(response: Object) {
  console.log('Cannot connect to HTTP server', response);
  throw Promise.resolve(errorObject);
}

export function jsonResponseCatcher(response: Object) {
  const contentType = response.headers.get('content-type');
  if (response.bodyValue && (!contentType || contentType.indexOf('application/json') === -1)) {
    console.log('Response type is not json', response);
    throw Promise.resolve(errorObject);
  }
  return response;
}

export function toJsonError(response: Object) {
  if (!response) {
    throw errorObject;
  }
  if (typeof response.then === 'function') {
    throw response;
  }
  const contentType = response.headers.get('content-type');
  if (!contentType || contentType.indexOf('application/json') === -1) {
    console.log('Response type is not JSON', response);
    throw errorObject;
  }
  throw response.json();
}

export default function handleError(response: Object) {
  if (response.status === 403) {
    refreshSessionToken();
    throw unauthorizedObject;
  }
  if (!response.ok) {
    throw response;
  }
  return response;
}
